<template>

    <v-content>
        <v-container fluid>

            <panelcontainer>
                <div class="headline" slot="headline">Satış / {{this.order_type.toUpperCase()}}</div>
                <div slot="actions">
                    <v-btn tile color="indigo" dark @click="editItem()">
                        <v-icon>{{mdiPlus}}</v-icon> Yeni Sipariş Ekle
                    </v-btn>
                </div>
               
 
				<table class="table table-striped table-borderless table-hover">
					<thead>
						<tr>
							<th>
								<v-text-field v-model="search_title" outlined dense clearable hide-details :label="empty_label" placeholder="Ara" x-small></v-text-field>
							</th>
							<th>
								<v-autocomplete v-if="getAuth.isAdmin" v-model="search_user_id" :items="users" item-value="id" item-text="fullname" :label="empty_label" outlined hide-details="" dense></v-autocomplete>
							</th>
							<th colspan="5"></th> 
						</tr>
						<tr>
							<th>Başlık</th>
							<th v-if="getAuth.isAdmin">Kullanıcı/Firma</th>
							<th>Durum</th>
							<th class="text-center" v-if="getAuth.isAdmin">Mail</th>
							<th>Bekleyen</th>
							<th>Tarih</th>
							<th style="width:1%;" class="actions"></th>
						</tr>
					</thead>
					<tbody class="no-border-x">
						<tr v-if="isLoading" >
							<td colspan="7"><loading text="Sipariş listesi yükleniyor..." size="80" width="2" /></td>
						</tr>
						<template v-if="!isLoading">
						<tr v-for="(item, itemIndex) in items" :key="itemIndex" @click="editItem(item)">
							<td class="cell-detail">
								<span><b>{{item.title}} </b> <small>[{{item.entries_count}} ürün]</small></span> 
								<span class="cell-detail-description">{{ item.date_add * 1000  | moment("DD.MM.YYYY hh:mm") }}</span>
								<!-- <span class="cell-detail-description">{{ [ item.add_date, "MM.DD.YY" ] | moment("dddd, MMMM Do YYYY") }}</span> -->
							</td>
							<td class="cell-detail" v-if="getAuth.isAdmin">
								<span><b>{{item.user.fullname}}</b></span>
								<span class="cell-detail-description">{{item.user.email}}</span>
							</td>
							<td>
								<v-chip class="ma-2" :color="statusColor[item.status_text]" :dark="item.status == 1" small label>{{item.status_text}}</v-chip>
							</td>
							<td align=center v-if="getAuth.isAdmin">
								<v-btn x-small large color="pink" icon v-if="item.mail_sended == 0">
									<v-icon>{{mdiEmailSend}}</v-icon>
								</v-btn>
								<v-icon color="green" v-if="item.mail_sended != 0">{{mdiBellCheck}}</v-icon>
							</td>
							<td>
								<v-chip class="ma-2" small color="pink" label text-color="white" v-if="item.waiting_count > 0">
									<v-icon left small>{{mdiTimerSand}}</v-icon> {{	item.waiting_count}}
								</v-chip>
							</td>
							<td class="cell-detail">
								<span>{{ item.date_delivery * 1000  | moment("DD.MM.YYYY") }}</span>
								<span class="cell-detail-description">{{ item.date_delivery * 1000  | moment("dddd") }}</span>
							</td>
							<td class="actions">
								<v-btn small icon color="indigo" dark>
                                        <v-icon>{{mdiSquareEditOutline}}</v-icon>
                                </v-btn>
							</td>
						</tr>
						</template>
					</tbody>
				</table>
				<v-row justify="center  p-0" v-if="count_page > 0">
					<v-col cols="8 pa-0">
						<v-container class="max-width  pa-0">
							<v-pagination v-model="page" class="mb-4" :length="count_page" :total-visible="8" color="red"></v-pagination>
						</v-container>
					</v-col>
				</v-row> 
            </panelcontainer>

            <v-layout row>

 



                <v-dialog v-model="dialogRemove" max-width="290">
                    <v-card>
                        <v-card-title class="headline" color="error"> Silmek itediğine emin misin ?</v-card-title>
                        <v-card-actions>
                            <v-btn color="green darken-1" text @click="closeForRemove()"> Vazgeç </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="error darken-1" text @click="removeItem()"> EMİNİM </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>





            </v-layout>
        </v-container>
    </v-content>


</template>


<script>
    import loading from "@/components/utils/loading"
    import panelcontainer from "@/components/utils/panelcontainer"
    import {
        mdiPlus,
        mdiCloseCircle,
        mdiBellCheck,
        mdiTimerSand,
        mdiEmailSend,
        mdiSquareEditOutline,
    } from '@mdi/js';
    export default {
        components: {
            loading,
            panelcontainer,
        },
        data: () => ({
            mdiPlus: mdiPlus,
            mdiCloseCircle: mdiCloseCircle,
            mdiBellCheck: mdiBellCheck,
            mdiTimerSand: mdiTimerSand,
            mdiEmailSend: mdiEmailSend,
            mdiSquareEditOutline: mdiSquareEditOutline,

            appLoaded: false,
            isLoading: true,
            dialogEditor: false,
			dialogRemove: false, 

			users : [],
			
			search_title : "",
			search_user_id : 0,
			search_unique : 0,
			
            count_total: 0,
            count_page: 0,
            page: 1,
			items: [ ], 
			
			empty_label : "",
			statusColor : {
				"Reddedildi" : "danger",
				"İptal Edildi" : "orange",
				"Bekliyor" : "",
				"Onaylandı" : "green",
			}
		}),
		watch : {
			search_title : function(n){
				this.loadItemsForSearch()
			},
			search_user_id : function(n){
				this.loadItemsForSearch()
			},
			page : function(n){
				this.loadItems()
			},
			order_type : function(n){
				this.loadItems()
			},
		},
		mounted(){ 
			this.loadUsers()  
			this.loadItems() 
		},
        methods: {
			loadUsers(){
				this.$http.get( process.env.VUE_APP_API_URL + "/users/shared", {
					params : { }
				}).then(response => {
					response.body.unshift({id : "",fullname :"Tümü"})
					this.users = response.body;  
				}) 
			},
			loadItemsForSearch(){ 
				if(this.appLoaded){
					this.loadItems();
				}
			},
			loadItems(){
				this.appLoaded = true;
				this.isLoading = true;
				var newUnique = Math.floor(Math.random() * 1000)
				this.search_unique = newUnique
				this.$http.get( process.env.VUE_APP_API_URL + "/orders/", {
					params : {
						order_type : this.order_type,
						search_title : this.search_title,
						search_user_id : this.search_user_id,
						page : this.page,
					}
				}).then(response => {  
					if(newUnique == this.search_unique){
						this.count_total = response.body.count_total; 
						this.count_page = response.body.count_page;  
						this.items = response.body.list; 
						this.isLoading = false; 
					}
				})  
			},
            editItem(item) {
				var link = "/orders/"+this.order_type+"/edit/"
				if(item){
					link += "?id=" + item.id
				} 
				window.open(link, '_blank'); 
            }, 
        },
		computed:{
			order_type(){
				return this.$route.params.order_type;
			},
			getAuth(){
				return this.$store.getters.getAuth;
			}
		}
    }
</script>

<style>

</style>